import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { MainBannerType, IReception, ICustomApp, NavigationLinkType, IColors } from '@sv/interfaces';
import { ReceptionService } from '../../../_services/_content/reception.service';
import { IAgenda } from '@sv/interfaces';
import { CustomAppService } from '../../../_services/_content/customApp.service';
import { customApp } from '../../../_configuration/configuration';
import { ShepherdService } from 'angular-shepherd';
import { TutorialService } from 'src/app/_services/_tutorial/tutorial.service';
import { NavigationService } from 'src/app/_services/_content/navigation.service';
import { AgendaService } from 'src/app/_services/_content/agenda.service';
import { WebsocketService } from 'src/app/_services/_content/websocket.service';
import { EventAnalyticsService } from 'src/app/_services/_analytics/event-analytics.service';

@Component({
  selector: 'app-reception',
  templateUrl: './reception.component.html',
  styleUrls: ['./reception.component.scss']
})
export class ReceptionComponent implements OnInit, AfterViewInit, OnDestroy {
  constructor(
    private receptionService: ReceptionService,
    private customAppService: CustomAppService,
    private shepherdService: ShepherdService,
    private tutorialService: TutorialService,
    private navigationService: NavigationService,
    private agendaService: AgendaService,
    private eventAnalyticsService: EventAnalyticsService
  ) {}

  activeReception: IReception;

  app: ICustomApp;
  colors: IColors;

  agenda: IAgenda;

  MainBannerType = MainBannerType;

  ngOnInit(): void {
    this.customAppService.getCustomAppListener().subscribe(async (app) => {
      this.app = app;
      this.colors = this.app.colors as IColors;
      if (typeof customApp.agenda === 'string') {
        this.agenda = await this.agendaService.getAgendaById(customApp.agenda);
      } else {
        this.agenda = customApp.agenda;
      }
    });

    // Get selected Reception Module from Service
    this.receptionService.getReceptionListener().subscribe((reception) => {
      this.activeReception = reception;
    });
  }

  async ngAfterViewInit() {
    const top = document.getElementById('top');
    if (top) {
      setTimeout(() => {
        top.scrollIntoView();
      }, 1);
    }
    if (
      sessionStorage.getItem('tutorial') === null &&
      (sessionStorage.getItem('reception') === null || sessionStorage.getItem('reception') === 'true')
    ) {
      let navigation = this.app.navigation;
      if (typeof navigation === 'string') {
        navigation = await this.navigationService.getNavigationById(navigation);
      }
      this.shepherdService.addSteps(this.tutorialService.getReceptionSteps(navigation.showDownloads, navigation.showSupport));
      this.shepherdService.tourObject.addStep(this.tutorialService.getNextModuleStep(navigation.links, NavigationLinkType.Reception));
      this.shepherdService.start();
    }
  }

  async ngOnDestroy() {
    if (sessionStorage.getItem('tutorial') === null) {
      if (sessionStorage.getItem('reception') === null) {
        sessionStorage.setItem('reception', 'true');
      } else {
        sessionStorage.setItem('reception', 'false');
      }
      this.shepherdService.complete();
    }
    await this.eventAnalyticsService.newCollectionRoomView();
  }
}
